import DevicesPage from 'pages/devices/[id]';

export default DevicesPage;